<template>
  <div id="usage-rules" class="content-section">
    <div class="section-title">用车规则</div>
    <div class="section-content">
      <div class="info-rows">
        <div class="info-row">
          <div class="info-label">行驶里程：</div>
          <div class="info-value">{{ useMileageDesc }}</div>
        </div>
        <div class="info-row">
          <div class="info-label">行驶区域：</div>
          <div class="info-value">{{ drivingAreaDesc }}</div>
        </div>
        <div class="info-row">
          <div class="info-label">提前还车：</div>
          <div class="info-value">
            <div class="info-value">{{ returnCarDesc }}</div>
          </div>
        </div>
        <div class="info-row">
          <div class="info-label">逾期还车：</div>
          <div class="info-value">{{ overdueReturnCarDesc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  notesVO: {
    type: Object,
    default: () => ({}),
  },
})

const useMileageDesc = computed(() => {
  const { useMileage = null, mileageShowLimit } = props.notesVO || {}
  if (useMileage === null) return '--'
  return useMileage ? mileageShowLimit : '不限制'
})

const drivingAreaDesc = computed(() => {
  const { drivingArea = null, drivingAreaLimit } = props.notesVO || {}
  if (drivingArea === null) return '--'
  return drivingArea ? drivingAreaLimit : '不限制'
})
const returnCarDesc = computed(() => {
  const { returnCar = null, returnCarLimit } = props.notesVO || {}
  if (returnCar === null) return '--'
  return returnCar ? returnCarLimit : '不限制'
})

const overdueReturnCarDesc = computed(() => {
  const { overdueReturnCar = null, overdueReturnCarLimit } = props.notesVO || {}
  if (overdueReturnCar === null) return '--'
  return overdueReturnCar ? overdueReturnCarLimit : '不限制'
})
</script>

<style lang="scss" scoped>
.content-section {
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

  .section-title {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    padding: 16px 20px;
  }

  .section-content {
    padding: 20px;
  }

  .info-rows {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .info-row {
      display: flex;

      .info-label {
        color: rgba(0, 0, 0, 0.6);
        font-size: 14px;
        flex-shrink: 0;
      }

      .info-value {
        color: #333333;
        font-size: 14px;
        flex: 1;
        word-break: break-all;
      }

      .highlighted-text {
        background-color: #e6f7ff;
        border: 1px solid #91d5ff;
        border-radius: 4px;
        padding: 0 4px;
        color: #1890ff;
        display: inline-block;
      }
    }
  }
}
</style>
